import React, { useEffect, useState } from 'react';
import { superApi } from './SuperAdminAuth';
import { toast } from 'sonner';
import { ScrollText } from 'lucide-react';

export const SuperAuditLogPage = () => {
  const [entries, setEntries] = useState([]);
  useEffect(() => {
    superApi.get('/super/audit-log?limit=500')
      .then((r) => setEntries(r.data.entries || []))
      .catch(() => toast.error('Failed to load audit log'));
  }, []);

  return (
    <div className="p-8 max-w-6xl mx-auto">
      <div className="mb-6 flex items-center gap-2">
        <ScrollText className="w-6 h-6 text-amber-400" />
        <h1 className="text-2xl font-semibold text-white">Audit Log</h1>
      </div>
      <div className="bg-slate-900 border border-slate-800 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-950 text-slate-400">
            <tr>
              <th className="text-left p-3">When</th><th className="text-left p-3">Actor</th>
              <th className="text-left p-3">Action</th><th className="text-left p-3">Target</th>
              <th className="text-left p-3">Details</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((e) => (
              <tr key={e.id} className="border-t border-slate-800">
                <td className="p-3 text-slate-400 whitespace-nowrap">{new Date(e.timestamp).toLocaleString()}</td>
                <td className="p-3 text-slate-300">{e.actor_email}</td>
                <td className="p-3 text-amber-400 font-mono text-xs">{e.action}</td>
                <td className="p-3 text-slate-400 text-xs">{e.target_type} {e.target_id ? `#${e.target_id.slice(0, 8)}` : ''}</td>
                <td className="p-3 text-xs text-slate-400 max-w-[400px] truncate">{JSON.stringify(e.details)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {entries.length === 0 && <div className="p-8 text-center text-slate-500 text-sm">No audit events yet.</div>}
      </div>
    </div>
  );
};

export default SuperAuditLogPage;
